<div class="skymiles-landing-page-summary">
  <h2 class="skymiles-landing-page-summary__header">{{ content.header }}</h2>
  <div class="skymiles-landing-page-summary__container">
    <div class="skymiles-landing-page-summary__container__miles">
      <div class="skymiles-landing-page-summary__container__label">
        {{ content.label }}
      </div>
      <div class="skymiles-landing-page-summary__container__title">
        {{ content.title }}
      </div>
    </div>
    <div class="skymiles-landing-page-summary__container__description">
      {{ content.description }}
    </div>
    <div class="skymiles-landing-page-summary__container__btn">
      <idp-button
        [label]="content.action.label"
        [size]="'full-width'"
        [type]="'secondary'"
        [id]="content.action.id || '#'"
        [ariaLabel]="content.action.label"
        [ariaPopup]="false"
        (notify)="goTo(content.action.link || '#')"
      ></idp-button>
    </div>
  </div>
</div>
